import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/core/auth/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyNotificationService } from '../../../../../notification/services/company-notification.service';

@Component({
  selector: 'kt-channel-control',
  templateUrl: './channel-control.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ChannelControlComponent implements OnInit {
  channelForm: FormGroup;
  configurableForm: FormGroup;
  @Input() channel;
  @Input() notification_id;
  @Input() level;
  @Input() related_id;
  constructor(
    private companyNotificationsService: CompanyNotificationService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.channelForm = this.fb.group({
      is_active: [this.channel.is_active],
    });
    this.configurableForm = this.fb.group({
      is_configurable: [this.channel.is_configurable],
    });
  }
  updateChannel() {
    const body = {
      id: this.channel.id,
      notification_id: this.notification_id,
      level: this.level,
      related_id: this.related_id,
      is_active: this.channelForm.controls.is_active.value,
      is_configurable: this.configurableForm.controls.is_configurable.value,
    };
    for (const [key, value] of Object.entries(body)) {
      if (typeof value === 'string') {
        body[key] = value.trim();
      }
    }
    this.companyNotificationsService.updateChannel(body).subscribe();
  }
}
